export default __webpack_public_path__ + "static/media/waiting-for-love.0d0f051a.png";